export type AuthStatus = "resolving" | "unauthenticated" | "authenticated";

export interface User {
  id: string;
  name: string;
  email: string;
}

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
] as const;

export type Province = (typeof PROVINCES)[number];

export interface GreenEnergyMetrics {
  compliancePct: number;
  embodiedCarbonKg: number;
  carbonPerM2: number;
  solar: {
    roofPitchDeg: number;
    orientation: string;
    annualYieldKwh: number;
    passiveGainPct: number;
  };
  ecoSwaps: { from: string; to: string; reductionPct: number; note: string }[];
}

export interface Project {
  id: string;
  name: string;
  province: Province | null;
  createdAt: string;
}
